/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/iosVersionMappers";
import * as Parameters from "../models/parameters";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a IosVersion. */
export class IosVersion {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a IosVersion.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Calls iOS Version Manager and returns the value
   * @summary Retrieves the latest supported iOS versions for iOS devices.
   * @param iOSDeviceModel
   * @param [options] The optional parameters
   * @returns Promise<Models.IosVersionGetIosVersionResponse>
   */
  getIosVersion(iOSDeviceModel: string, options?: coreHttp.RequestOptionsBase): Promise<Models.IosVersionGetIosVersionResponse>;
  /**
   * @param iOSDeviceModel
   * @param callback The callback
   */
  getIosVersion(iOSDeviceModel: string, callback: coreHttp.ServiceCallback<string[]>): void;
  /**
   * @param iOSDeviceModel
   * @param options The optional parameters
   * @param callback The callback
   */
  getIosVersion(iOSDeviceModel: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<string[]>): void;
  getIosVersion(iOSDeviceModel: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<string[]>, callback?: coreHttp.ServiceCallback<string[]>): Promise<Models.IosVersionGetIosVersionResponse> {
    return this.client.sendOperationRequest(
      {
        iOSDeviceModel,
        options
      },
      getIosVersionOperationSpec,
      callback) as Promise<Models.IosVersionGetIosVersionResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const getIosVersionOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/IosVersion/{iOSDeviceModel}",
  urlParameters: [
    Parameters.iOSDeviceModel
  ],
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      }
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
